import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

type Loaders = 'maxDiscountDepth' | 'maxDiscountLength' | 'productHistory' | 'recommendedDates' | 'opportunityStartDate' | 'discountConfig'

export const useLoadersStore = defineStore('loaders', () => {
	const activeLoaders = ref(new Set<Loaders>())

	const isActive = computed(() => {
		return (loader: Loaders) => activeLoaders.value.has(loader)
	})

	function activate(loader: Loaders) {
		activeLoaders.value.add(loader)
	}

	function deactivate(loader: Loaders) {
		activeLoaders.value.delete(loader)
	}

	return {
		activate,
		deactivate,
		isActive,
		activeLoaders
	}
})
